<div class="bg-white rounded-2xl shadow-xl border border-gray-100 p-6">
  <div class="flex items-start justify-between mb-4 gap-4 flex-wrap">
    <div>
      <h3 class="text-lg font-bold text-gray-900">Huella de auditoría</h3>
      <p class="text-sm text-gray-500">Quién hizo qué y cuándo en esta inscripción.</p>
    </div>
    <div class="flex items-center gap-2 flex-wrap">
      <select
        class="text-sm border border-gray-200 rounded-lg px-3 py-1.5 bg-white"
        [ngModel]="selectedCategory"
        (ngModelChange)="onCategoryChange($event)">
        <option *ngFor="let c of categories" [ngValue]="c.value">{{ c.label }}</option>
      </select>
      <label class="inline-flex items-center gap-2 text-sm text-gray-600 cursor-pointer select-none">
        <input type="checkbox" [checked]="showAccess" (change)="toggleAccess()" class="rounded" />
        Mostrar accesos
      </label>
      <button type="button" (click)="load()"
        class="text-sm px-3 py-1.5 border border-gray-200 rounded-lg hover:bg-gray-50">
        Actualizar
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="py-12 text-center text-gray-500">Cargando historial…</div>

  <div *ngIf="error && !loading" class="py-6 text-center text-red-600 bg-red-50 rounded-lg border border-red-100">
    {{ error }}
  </div>

  <div *ngIf="!loading && !error">
    <div *ngIf="visibleEntries().length === 0" class="py-12 text-center text-gray-500 border border-dashed border-gray-200 rounded-lg">
      No hay registros para el filtro seleccionado.
    </div>

    <ul *ngIf="visibleEntries().length > 0" class="space-y-3">
      <li *ngFor="let entry of visibleEntries()"
        class="border rounded-xl p-4 transition-colors"
        [ngClass]="colorForCategory(entry.category)">
        <div class="flex items-start gap-3">
          <div class="text-2xl leading-none">{{ iconForCategory(entry.category) }}</div>
          <div class="flex-1 min-w-0">
            <div class="flex items-center justify-between gap-3 flex-wrap">
              <div class="font-semibold text-gray-900">{{ entry.summary }}</div>
              <span class="text-xs px-2 py-0.5 rounded-full bg-white/70 border border-current">
                {{ entry.categoryName }}
              </span>
            </div>
            <div class="mt-1 text-xs text-gray-600 flex items-center gap-2 flex-wrap">
              <span title="{{ entry.performedAt }}">{{ entry.performedAt | date:'dd/MM/yyyy HH:mm' }}</span>
              <span>•</span>
              <span>{{ entry.performedByFullName || entry.performedByEmail }}</span>
              <span *ngIf="entry.performedByEmail && entry.performedByEmail !== entry.performedByFullName" class="text-gray-400">
                &lt;{{ entry.performedByEmail }}&gt;
              </span>
            </div>
            <div *ngIf="entry.reason" class="mt-2 text-sm italic text-gray-700">
              Motivo: {{ entry.reason }}
            </div>

            <button type="button" (click)="toggleExpand(entry.id)"
              class="mt-2 text-xs underline text-blue-700 hover:text-blue-900">
              {{ isExpanded(entry.id) ? 'Ocultar detalle' : 'Ver detalle (antes/después)' }}
            </button>

            <div *ngIf="isExpanded(entry.id)" class="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <div class="text-xs font-semibold text-gray-500 mb-1">Antes</div>
                <pre class="text-xs bg-white/80 p-2 rounded border border-gray-200 overflow-auto max-h-48">{{ prettyJson(entry.beforeJson) }}</pre>
              </div>
              <div>
                <div class="text-xs font-semibold text-gray-500 mb-1">Después</div>
                <pre class="text-xs bg-white/80 p-2 rounded border border-gray-200 overflow-auto max-h-48">{{ prettyJson(entry.afterJson) }}</pre>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <div *ngIf="totalCount > pageSize" class="mt-4 flex items-center justify-between text-sm text-gray-600">
      <div>Total: {{ totalCount }} registros</div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="prevPage()" [disabled]="pageNumber <= 1"
          class="px-3 py-1 border rounded-lg disabled:opacity-50">Anterior</button>
        <span>Página {{ pageNumber }} de {{ totalPages }}</span>
        <button type="button" (click)="nextPage()" [disabled]="pageNumber >= totalPages"
          class="px-3 py-1 border rounded-lg disabled:opacity-50">Siguiente</button>
      </div>
    </div>
  </div>
</div>
